import { ref, reactive } from "vue";

// Глобальное состояние уведомлений
const notifications = ref([]);

// Счетчик для уникальных ID
let notificationId = 0;

export function useNotifications() {
  // Добавление уведомления
  const addNotification = (notification) => {
    const id = ++notificationId;
    const defaultNotification = {
      id,
      message: "",
      type: "success", // success, error, warning, info
      lifeTime: 5000, // время жизни в миллисекундах
      ...notification
    };
    
    notifications.value.push(defaultNotification);
    
    // Автоматическое удаление через lifeTime
    if (defaultNotification.lifeTime > 0) {
      setTimeout(() => {
        removeNotification(id);
      }, defaultNotification.lifeTime);
    }
    
    return id;
  };

  // Удаление уведомления по ID
  const removeNotification = (id) => {
    const index = notifications.value.findIndex(notification => notification.id === id);
    if (index > -1) {
      notifications.value.splice(index, 1);
    }
  };

  // Очистка всех уведомлений
  const clearNotifications = () => {
    notifications.value = [];
  };

  // Утилиты для быстрого создания уведомлений разных типов
  const success = (message, options = {}) => {
    return addNotification({
      message,
      type: "success",
      ...options
    });
  };

  const error = (message, options = {}) => {
    return addNotification({
      message,
      type: "error",
      lifeTime: 8000, // ошибки показываем дольше
      ...options
    });
  };

  const warning = (message, options = {}) => {
    return addNotification({
      message,
      type: "warning",
      lifeTime: 6000,
      ...options
    });
  };

  const info = (message, options = {}) => {
    return addNotification({
      message,
      type: "info",
      ...options
    });
  };

  return {
    notifications,
    addNotification,
    removeNotification,
    clearNotifications,
    success,
    error,
    warning,
    info
  };
}